//默认配置
const config = {
   debug : false,
   systemName : '上海康复医学会',
   url : window.location.origin+window.location.pathname
}
config.projectType = process.env.NODE_ENV;
//不同环境配置不一样
if(process.env.NODE_ENV == 'test'){
   //测试环境
   config.basePath = 'http://yun.shinoa.cn:19001';
}else if(process.env.NODE_ENV == 'prod'){
   //生产环境
   config.basePath = 'http://139.196.150.180:8088';
}else if(process.env.NODE_ENV == 'prod_shhd'){
   //上海华东
   config.basePath = 'http://139.196.150.180:8088';
}else{
   //开发环境
   config.debug = true;
   config.basePath = 'http://139.196.150.180:8088';
}

//api地址
if(!config.apiPath){
   config.apiPath = config.basePath+'/edu/';
}

//通用资源地址
if(!config.commonPath){
   config.commonPath = config.basePath+'/hhcommon';
}

//文件地址
if(!config.filePath){
   config.filePath = config.basePath+'/uploadfile';
}

//根据id获取文件地址
if(!config.fileRequestPath){
   config.fileRequestPath = config.apiPath+'public/api/system/file/download.request?id=';
}

export default config



// WEBPACK FOOTER //
// ./src/config.js